var _g, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_143_1",
    "data-name": "Component 143 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 32,
    viewBox: "0 0 73 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apps",
    transform: "translate(41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 32,
    height: 32,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M24,24H18V18h6v6Zm-9,0H9V18h6v6ZM6,24H0V18H6v6Zm18-9H18V9h6v6Zm-9,0H9V9h6v6ZM6,15H0V9H6v6ZM24,6H18V0h6V6ZM15,6H9V0h6V6ZM6,6H0V0H6V6Z",
    transform: "translate(4 4)",
    fill: "#312929"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "MENY",
    transform: "translate(0 21)",
    fill: "#333",
    fontSize: 12,
    fontFamily: "Inter-Medium, Inter",
    fontWeight: 500,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MENY"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.a41dd2917db0f484fdd98f6dea6251d6.svg";
export { ForwardRef as ReactComponent };